import { definePreset } from "@primeng/themes";
import Aura from "@primeng/themes/aura";

const AeoCloudPreset = definePreset(Aura, {
	semantic: {
		aeotec: {
			50: "#e0f7fc",
			100: "#b3e8f9",
			200: "#80d7f3",
			300: "#4dc6ed",
			400: "#26b5e6",
			500: "#00a6e1",
			600: "#00A3E0",
			700: "#008fc3",
			800: "#0077a1",
			900: "#005c7d",
			950: "#003d56",
		},
		primary: {
			50: "{aeotec.50}",
			100: "{aeotec.100}",
			200: "{aeotec.200}",
			300: "{aeotec.300}",
			400: "{aeotec.400}",
			500: "{aeotec.500}",
			600: "{aeotec.600}",
			700: "{aeotec.700}",
			800: "{aeotec.800}",
			900: "{aeotec.900}",
			950: "{aeotec.950}",
		},
		colorScheme: {
			light: {
				primary: {
					color: "{aeotec.600}",
					inverseColor: "#ffffff",
					hoverColor: "{aeotec.900}",
					activeColor: "{aeotec.800}",
				},
				highlight: {
					background: "{aeotec.600}",
					focusBackground: "{aeotec.700}",
					color: "#ffffff",
					focusColor: "#ffffff",
				},
			},
			dark: {
				primary: {
					color: "{aeotec.50}",
					inverseColor: "{aeotec.950}",
					hoverColor: "{aeotec.100}",
					activeColor: "{aeotec.200}",
				},
				highlight: {
					background: "rgba(250, 250, 250, .16)",
					focusBackground: "rgba(250, 250, 250, .24)",
					color: "rgba(255,255,255,.87)",
					focusColor: "rgba(255,255,255,.87)",
				},
			},
		},
	},
});

export default AeoCloudPreset;
